// src/mixins/clickMixin.js

export default function (){
    return{
        methods: {
            getFileOriginalName(file){
                return file.substr(file.lastIndexOf('/')+1)
            },
            getformatDate(value) {
                if (value) {
                    return Intl.DateTimeFormat('fr-FR', {
                        year: 'numeric',
                        month: 'short',
                        day: '2-digit',
                        hour: "numeric",
                        minute: "2-digit",
                        second: "2-digit"
                    }).format(new Date(value));
                }
            },
        }
    }

}
